<div class="mx-auto grid max-w-sm grid-cols-3 gap-3 p-4">
  <!-- Les chiffres 1-9 -->
  <ng-container *ngFor="let number of [1, 2, 3, 4, 5, 6, 7, 8, 9, 'empty', 0, 'delete']">
    <!-- Chiffres -->
    <div
      *ngIf="number !== 'empty' && number !== 'delete'"
      role="button"
      class="flex h-14 w-full items-center justify-center rounded-lg bg-primary-600 text-2xl text-white shadow cursor-pointer active:scale-95 transition-transform"
      (click)="onNumberClick(forceType(number))"
    >
      {{ number }}
    </div>

    <!-- Espace vide pour l'alignement -->
    <div
      *ngIf="number === 'empty'"
      class="h-14"
    ></div>

    <!-- Suppression -->
    <div
      *ngIf="number === 'delete'"
      role="button"
      class="flex h-14 w-full items-center justify-center rounded-lg bg-primary-600 text-2xl text-white shadow cursor-pointer active:scale-95 transition-transform"
      (click)="onDeleteClick()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="h-6 w-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </div>
  </ng-container>
</div>
